// Maps the data's raw title type codes (e.g. '13-TVSERIES') to display labels.
export function getTitleTypeLabel(type) {
  switch (type?.toUpperCase()) {
    case '03-DOCUMENTARY':
      return 'Documentary'
    case '12-TVMINI-SERIES':
    case '13-TVSERIES':
      return 'Series'
    // '01-MOVIE', '02-VIDEO', '11-TVMOVIE', 'TV-14SPECIAL', '99-OTHER', '21-SHORT' and anything unknown
    default:
      return 'Movie'
  }
}
